/**
 * Declarative Retail Studio workspace capabilities.
 *
 * This module owns capability declaration and automatic
 * workspace projection only.
 *
 * It owns no Cart, Checkout, Payment, Receipt, Inventory
 * or other live business behavior.
 */

export const RETAIL_POS_WORKSPACE_CAPABILITIES =
  Object.freeze([
    Object.freeze({
      id: "checkout",
      label: "Checkout",
      description:
        "Parcours standard de vente Retail : panier, validation, paiement et ticket.",
      automatic: true,
    }),
  ]);


export function createDefaultRetailPOSWorkspaces() {
  return RETAIL_POS_WORKSPACE_CAPABILITIES
    .filter(
      (capability) =>
        capability.automatic === true
    )
    .map(
      (capability) =>
        Object.freeze({
          id:
            capability.id,
        })
    );
}


export function projectRetailPOSWorkspaces(
  configuredWorkspaces
) {
  if (
    Array.isArray(configuredWorkspaces)
    && configuredWorkspaces.length > 0
  ) {
    return configuredWorkspaces;
  }

  return createDefaultRetailPOSWorkspaces();
}
